import React from "react";
import {
  Switch,
  Redirect,
  Route,
  withRouter,
  useRouteMatch
} from "react-router-dom";
import FindEmail from "Pages/Dashboard/data-toolkit/find-email/FindEmail";
import ValidateEmails from "Pages/Dashboard/data-toolkit/validate/ValidateEmails";
import EnrichContacts from "Pages/Dashboard/data-toolkit/enrich-contacts/EnrichContacts";
import EnrichAccounts from "Pages/Dashboard/data-toolkit/enrich-accounts/EnrichAccounts";
// Data Magic is hidden for now (see constants.js `hidden`); route restored with it.
// import DataMagic from "Pages/Dashboard/data-toolkit/data-magic/DataMagic";

const DataToolkitRouting = () => {
  let { path = "" } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={`${path}/find-email`} component={FindEmail} />
      <Route exact path={`${path}/validate`} component={ValidateEmails} />
      <Route
        exact
        path={`${path}/enrich-contacts`}
        component={EnrichContacts}
      />
      <Route
        exact
        path={`${path}/enrich-accounts`}
        component={EnrichAccounts}
      />
      {/* <Route exact path={`${path}/data-magic`} component={DataMagic} /> */}
      <Redirect from={path} to={`${path}/find-email`} />
    </Switch>
  );
};

export default withRouter(DataToolkitRouting);
